/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents the kind of a person in a people picker: one of the
 * organization's students, parents or tutors, or one of its admins.
 */
export enum RecentKind {
  STUDENT = "student",
  PARENT = "parent",
  TUTOR = "tutor",
  ADMIN = "admin",
}
